import React from 'react';
import { ListItem } from './list-item';
import { ListResultsProps } from 'app/area/subscriber-groups/list/types-store';
import styles from './list-results.scss';

export const ListResults: React.FC<ListResultsProps> = ({
  listItems, translation, mergeSubscriberGroup, updateMergeSubscriberGroup
}) => listItems?.length > 0
    ? <div className={styles.listItems}>
      {listItems.map(listItem => {
        return <ListItem
          key={listItem.id}
          item={listItem}
          deleting={mergeSubscriberGroup?.id === listItem.id && mergeSubscriberGroup?.fetching}
          mergeSubscriberGroup={mergeSubscriberGroup}
          updateMergeSubscriberGroup={updateMergeSubscriberGroup}
          translation={translation} />;
      })}
    </div>
    : null;
